module.exports = __webpack_public_path__ + "img/Stacks of Syrian pounds.8f9a11f1.jpg";